module.exports = __webpack_public_path__ + "img/icon-35.55a1127a.png";